(function () {
  var doc = document;
  var win = window;
  var reduceMotion = win.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = win.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (reduceMotion || !finePointer) {
    doc.documentElement.classList.remove('bk-mouse-stalker-pending');
    return;
  }

  function init() {
    if (!doc.body || doc.querySelector('.bk-mouse-stalker')) return;

    var stalker = doc.createElement('div');
    var circle = doc.createElement('span');
    var clickableSelector = [
      'a[href]',
      'button:not([disabled])',
      'summary',
      'input:not([disabled])',
      'textarea:not([disabled])',
      'select:not([disabled])',
      'label',
      '[role="button"]',
      '[tabindex]:not([tabindex="-1"])',
      '[data-bk-cart-open]',
      '.shopify-payment-button__button',
    ].join(',');

    var targetX = -100;
    var targetY = -100;
    var currentX = targetX;
    var currentY = targetY;
    var rafId = 0;
    var isVisible = false;
    var storedPointKey = 'bkMouseStalkerPoint';

    stalker.className = 'bk-mouse-stalker';
    stalker.setAttribute('aria-hidden', 'true');
    stalker.appendChild(circle);
    doc.body.appendChild(stalker);
    doc.documentElement.classList.remove('bk-mouse-stalker-pending');
    doc.documentElement.classList.add('bk-mouse-stalker-ready');

    function render() {
      var dx = targetX - currentX;
      var dy = targetY - currentY;

      currentX += dx * 0.18;
      currentY += dy * 0.18;

      if (Math.abs(dx) < 0.02 && Math.abs(dy) < 0.02) {
        currentX = targetX;
        currentY = targetY;
        rafId = 0;
      } else {
        rafId = win.requestAnimationFrame(render);
      }

      stalker.style.transform =
        'translate3d(' + currentX + 'px, ' + currentY + 'px, 0) translate(-50%, -50%)';
    }

    function start() {
      if (!rafId) rafId = win.requestAnimationFrame(render);
    }

    function setClickable(target) {
      var clickable = Boolean(target && target.closest && target.closest(clickableSelector));
      stalker.classList.toggle('is-link', clickable);
    }

    function show(event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;

      targetX = event.clientX;
      targetY = event.clientY;

      if (!isVisible) {
        isVisible = true;
        currentX = targetX;
        currentY = targetY;
        stalker.classList.add('is-visible');
        stalker.style.transform =
          'translate3d(' + currentX + 'px, ' + currentY + 'px, 0) translate(-50%, -50%)';
      }

      setClickable(event.target);
      start();
    }

    function hide() {
      isVisible = false;
      stalker.classList.remove('is-visible', 'is-link');
    }

    function restoreStoredPoint() {
      try {
        var raw = sessionStorage.getItem(storedPointKey);
        sessionStorage.removeItem(storedPointKey);
        if (!raw) return;

        var point = JSON.parse(raw);
        if (
          !point ||
          Date.now() - point.t > 5000 ||
          typeof point.x !== 'number' ||
          typeof point.y !== 'number'
        ) {
          return;
        }

        targetX = point.x;
        targetY = point.y;
        currentX = targetX;
        currentY = targetY;
        isVisible = true;
        stalker.classList.add('is-visible');
        stalker.style.transform =
          'translate3d(' + currentX + 'px, ' + currentY + 'px, 0) translate(-50%, -50%)';
      } catch (e) {}
    }

    doc.addEventListener('pointermove', show, { passive: true });
    doc.documentElement.addEventListener('mouseleave', hide);
    win.addEventListener('blur', hide);
    restoreStoredPoint();
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
